export enum UserPermissions {
  SearchUser = "SEARCH_USER",
  RegisterUser = "ADD_USER",
  EditUser = "EDIT_USER",
  SearchCompany = "SEARCH_COMPANY",
  RegisterCompany = "ADD_COMPANY",
  EditCompany = "EDIT_COMPANY",
  SearchBeneficiary = "SEARCH_BENEFICIARY",
  RegisterBeneficiary = "ADD_BENEFICIARY",
  EditBeneficiary = "EDIT_BENEFICIARY",
  BeneficiaryBlockCard = "BENEFICIARY_BLOCK_CARD",
  BeneficiaryReactivateCard = "BENEFICIARY_REACTIVATE_CARD",
  AddCampaign = "ADD_CAMPAIGN",
  EditCampaign = "EDIT_CAMPAIGN",
  SearchCampaign ="SEARCH_CAMPAIGN",
  SearchBenefit = "SEARCH_BENEFIT",
  RegisterBenefit = "ADD_BENEFIT",
  EditBenefit = "EDIT_BENEFIT",
  SearchSalesHistory = "SEARCH_SALES_HISTORY",
  SearchFinancialStatement = "SEARCH_FINANCIAL_STATEMENT",
  SearchNetworkFinancialStatement = "SEARCH_NETWORK_FINANCIAL_STATEMENT",
  ViewCompanyFinancialReport = "VIEW_COMPANY_FINANCIAL_REPORT",
  ViewGeneralReport = "VIEW_GENERAL_REPORT",
  ViewAudit = "VIEW_AUDIT",
  SearchNetworkTerm = "SEARCH_NETWORK",
  EditNetworkTerm = "EDIT_NETWORK",
  ViewLpmManagement = "SEARCH_INDUSTRY_DISCOUNT",
  SearchProduct = "SEARCH_PRODUCT",
  InsertProduct = "INSERT_PRODUCT",
  EditProduct = "EDIT_PRODUCT",
  DeleteProduct = "DELETE_PRODUCT",
  SearchProductPrincing = "SEARCH_PRODUCT_PRICING",
  InsertProductPrincing = "INSERT_PRODUCT_PRICING",
  EditProductPricing = "EDIT_PRODUCT_PRICING",
  DeleteProductPrincing = "DELETE_PRODUCT_PRICING",
  TransactionalManagement = "VIEW_TRANSACTIONAL_MANAGEMENT",
  EditTransactionalManagement = "EDIT_TRANSACTIONAL_MANAGEMENT",
  SearchPractitioner = "SEARCH_PRACTITIONER",
  RegisterPractitioner = "ADD_PRACTITIONER",
  EditPractitioner = "EDIT_PRACTITIONER",
  PDVTest = "PDV_TESTE",
  ViewCluster = "VIEW_CLUSTER",
  EditCluster = "EDIT_CLUSTER",
  EditCycleLimit = "EDIT_CYCLE_LIMIT",
  ViewDeliveryPanel = "VIEW_DELIVERY_PANEL",
  EditDeliveryPanel = "EDIT_DELIVERY_PANEL",
  CompensateDeliveryPanel = "COMPENSATE_DELIVERY_PANEL"
}
